import { Content, List, Root as Tabs, Trigger } from '@radix-ui/react-tabs';
import React, { Dispatch, SetStateAction, memo } from 'react';

import { AnchorLink } from 'components/anchorLink';
import { Wrapper } from 'components/wrapper';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import styles from './TabsContainer.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useSelector } from 'react-redux';
import useWindowSize from 'hooks/useWindowSize';

export type TabsContainerProps = {
  title: string;
  tabs: string[];
  children: React.ReactNode;
  selectedTab: number;
  hasPaddingTop?: boolean;
  hasPaddingBottom?: boolean;
  seeMoreLink?: string;
  className?: string;
  setSelectedTab: Dispatch<SetStateAction<number>>;
};
export const TabsContainer = memo(function TabsContainer({
  title,
  tabs,
  children,
  selectedTab,
  setSelectedTab,
  hasPaddingTop,
  hasPaddingBottom,
  seeMoreLink,
  className,
}: TabsContainerProps) {
  const { isMobile } = useWindowSize();

  const isOpen = useSelector(selectIsOpenCarrello);

  const viewAllLabel = useGetLabelByKey('view-all');
  const handleTabs = (index: number) => {
    setSelectedTab(index);
  };

  return (
    <Wrapper
      bgColorTransparent
      noPaddingRight={isMobile || isOpen}
      noPaddingLeft
      noPaddingTop={!hasPaddingTop}
      noPaddingBottom={!hasPaddingBottom}
      className={className}
    >
      <div className={styles.container}>
        <h2 className={styles.title}>{title}</h2>

        <Tabs defaultValue={tabs[selectedTab]} className={styles.root}>
          <List className={styles.tabList}>
            {tabs &&
              tabs.map((tab, index) => {
                return (
                  <React.Fragment key={tab + '_' + index}>
                    <Trigger value={tab} onClick={() => handleTabs(index)} className={styles.tab}>
                      {tab}
                    </Trigger>
                  </React.Fragment>
                );
              })}
          </List>
          {/* content */}
          <Content value={tabs[selectedTab]}>{children}</Content>
          {seeMoreLink && (
            <div className={styles.footerTab}>
              <AnchorLink href={`${seeMoreLink}`} className={styles.link}>
                {viewAllLabel}
              </AnchorLink>
            </div>
          )}
        </Tabs>
      </div>
    </Wrapper>
  );
});
